






























































import {mapGetters} from 'vuex';

export default {
  props: ['hideMobileLogo'],
  computed: {
    ...mapGetters(['authUser']),
    accountLink(): any {
      if (this.authUser && (this.authUser as any).country) {
        return {name: 'Account'};
      }
      return {name: 'SelectRegion'};
    },
    profileLink(): any {
      if (this.authUser && (this.authUser as any).country) {
        return {name: 'Profile'};
      }
      return {name: 'SelectRegion'};
    }
  },
  data(): any {
    return {
      showMobileMenu: false
    }
  },
  methods: {
    openMenu(): void {
      const vm = this as any;
      setTimeout(() => {
        vm.showMobileMenu = true
      }, 300);
    }
  }
}
